import React, { Component } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import authStore from '../../../Auth/AuthStore';
import mainStore from '../../../../MainStore';
import WorkStore from '../../Kanban/WorkStore';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import UserSelect from '../../Users/UserSelect';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import WorkSelect from '../../Work/WorkSelect';
import { fetchWithAuth } from '../../../Auth/GlobalFetchWithAuth';
import Alert from '@mui/material/Alert';
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from '@mui/material/CircularProgress';

export default class ApprovalPath extends Component {
    constructor(props) {
        super(props);
        this.state = {
            approvals: [],
            approvalInfo: {},
            isShowSaveAlert: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.addNewApproval = this.addNewApproval.bind(this);
        this.createApprovalTasks = this.createApprovalTasks.bind(this);
        this.handleOwnerChange = this.handleOwnerChange.bind(this);
        this.handleEmailNotificationChange = this.handleEmailNotificationChange.bind(this);
        this.handleWorkChange = this.handleWorkChange.bind(this);
        this.saveApprovals = this.saveApprovals.bind(this);
        this.handleApprovalInfoChange = this.handleApprovalInfoChange.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleOrderChange = this.handleOrderChange.bind(this);
    }

    componentWillMount() {
        if (!this.props.workId) return;
        let scope = this;
        mainStore.setMaskVisible();
        fetchWithAuth('api/Approval?workId=' + this.props.workId,
            null,
            "application/json",
            (result) => {
                mainStore.setMaskUnvisible();
                scope.setState({ approvals: result.approvals, approvalInfo: Object.assign({}, result.approvalInfo) });
            },
            "GET"
        );
    }
    handleOrderChange = id => evt => {
        let approvals = this.state.approvals.slice(0);
        var index = approvals.findIndex(a => a.id === id);

        if (index > -1) {
            approvals[index].order = evt.target.value;
        }
        this.setState({ approvals: approvals });
    }

    handleCommentChange(data) {
        this.setState({ "comment": data });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ "comment": data });
        }
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });

        if (this.props.handleParentChange) {
            this.props.handleParentChange({ [name]: evt.target.value });
        }
    }

    saveApprovals(callback) {
        let scope = this;
        scope.setState({ isShowSaveAlert: false });
        mainStore.setMaskVisible();
        fetchWithAuth('api/Approval',
            JSON.stringify({
                workId: this.props.workId, approvals: this.state.approvals,
                td: this.state.approvalInfo.td,
                conception: this.state.approvalInfo.conception,
                description: this.state.approvalInfo.description,
                cases: this.state.approvalInfo.cases,
            }),
            "application/json",
            (result) => {
                mainStore.setMaskUnvisible();

                scope.setState({ isShowSaveAlert: true });
                callback.call(scope);
            },
            "POST"
        );
    }

    handleOwnerChange = id => evt => {
        let approvals = this.state.approvals.slice(0);
        var index = approvals.findIndex(a => a.id === id);

        if (index > -1) {
            approvals[index].ownerId = evt.id;
            approvals[index].ownerName = evt.name;
        }
        this.setState({ approvals: approvals });
    }

    handleDeleteClick = id => evt => {
        let scope = this;
        scope.setState({ sShowSaveAlert: false });
        mainStore.setMaskVisible();
        fetchWithAuth('api/Approval/Delete',
            JSON.stringify(id),
            "application/json",
            (result) => {
                mainStore.setMaskUnvisible();
                let approvals = this.state.approvals.slice(0);

                var index = approvals.findIndex(a => a.id == id);

                approvals.splice(index, 1);

                scope.setState({ isShowSaveAlert: true, approvals: approvals });
            },
            "POST"
        );
    }

    handleEmailNotificationChange = id => evt => {
        let approvals = this.state.approvals.slice(0);
        var index = approvals.findIndex(a => a.id === id);

        if (index > -1) {
            approvals[index].isNeedEmail = evt.target.checked;
        }
        this.setState({ approvals: approvals });
    }

    handleWorkChange = id => evt => {
    }

    createApprovalTasks = isOnlyNew => () => {
        let scope = this;
        scope.setState({ isShowSaveAlert: false, isInSaving: true });
        mainStore.setMaskVisible();
        this.saveApprovals(() => {
            fetchWithAuth('api/Approval/Start',
                JSON.stringify({
                    workId: this.props.workId,
                    isOnlyNew: isOnlyNew
                }),
                "application/json",
                (result) => {
                    mainStore.setMaskUnvisible();

                    var work = WorkStore.getWork;
                    work.isFlagged = true;
                    if (WorkStore.getWork.assigneeRoleId === "acb6da3b-7b1c-43c7-af1a-b02226ce32ec") {
                        work.statusId = "b555b916-8367-46f5-8200-594c2fdf7443";
                    }
                    else {
                        work.statusId = "e3e8b238-a870-4dc1-ab2b-e2cbe7f9b6dc";
                    }
                    WorkStore.setWork(work);

                    WorkStore.updateWork(work);

                    scope.setState({ approvals: result.approvals, isInSaving: false });
                },
                "POST"
            );
        });
    }

    addNewApproval() {
        let approvals = this.state.approvals.slice(0);

        approvals.push({
            caption: "Доп. согласующий",
            statusName: "Новое",
            id: mainStore.uuidv4
        });

        this.setState({ approvals: approvals });
    }

    handleApprovalInfoChange = field => evt => {
        var approvalInfo = this.state.approvalInfo;
        approvalInfo[field] = evt.target.value;
        this.setState({ approvalInfo: approvalInfo });
    }

    render() {
        var approvals = this.state.approvals && this.state.approvals.map(c =>
            <Card key={c.id} className="comment-card">
                <CardContent>
                    
                    <Typography color="textSecondary" gutterBottom>
                        {c.caption} - <b>{c.statusName}</b>
                        {!c.approvalWorkId && <IconButton className="approval-path-delete-icon" onClick={this.handleDeleteClick(c.id)}>
                            <ClearIcon />
                        </IconButton>}
                    </Typography>
                    <div className="clearfix approval-main-block">
                        <div className="approval-main-left-block">
                            <div>
                                <TextField className="approval-main-block-order" required
                                    InputLabelProps={{ shrink: true }}
                                    id="standard-fact-required"
                                    label="Порядок"
                                    fullWidth
                                    variant="standard"
                                    type="number"
                                    margin="none"
                                    value={c.order}
                                    onChange={this.handleOrderChange(c.id)}
                                />
                                <div className="approval-main-block-lookup">
                                    <UserSelect name={c.ownerName} id={c.ownerId} label="Ответственный" handleSelect={this.handleOwnerChange(c.id)} />
                                </div>
                                <div className="approval-main-block-lookup">
                                    <WorkSelect name={c.approvalWorkNumber} id={c.approvalWorkId} key="work-parent-select" handleSelect={this.handleWorkChange(c.Id)} label="Задача" />
                                </div>
                            </div>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={c.isNeedEmail} onChange={this.handleEmailNotificationChange(c.id)} value="true" />
                                }
                                label="Отправить email-уведомление"
                            />
                        </div>
                        <div className="approval-main-right-block">
                            <div className="approval-comment-block">
                                <div><b>Комментарий</b></div>
                                {c.comment}
                            </div>

                            
                        </div>
                    </div>
                </CardContent>
                {false && <CardActions>
                    <Button size="small">Edit</Button>
                </CardActions>}
            </Card>);
        return (
            <div className="full-width approval-block">
                <div className="">
                    {approvals}
                </div>
                
                {this.state.isInSaving && <CircularProgress />}
                {false && <Button onClick={this.saveApprovals}>Сохранить изменения</Button>}

                {!this.state.isInSaving && <>
                    <div className="approval-button-row"><Button className="approval-button-fixed" variant="contained" color="success" onClick={this.createApprovalTasks(false)}>Запустить согласование</Button></div>
                    <div className="approval-button-row">
                        <Button className="approval-button-fixed" variant="contained" onClick={this.addNewApproval}>Добавить согласующего</Button>
                        <Button className="approval-button grey" variant="outlined" color="secondary" onClick={this.createApprovalTasks(true)}>Направить на согласование новым согласующим</Button>
                    </div>
                </>}
                
                {this.state.isShowSaveAlert && <Alert onClose={() => { this.setState({ isShowSaveAlert : false}) }}>Saved!</Alert>}
            </div>
        );
    }
}
